import { Modal } from "react-bootstrap";

function ErrorfeedbackModal({ isShow, onHide, message, onHideUploadModal, setErrorMessage, setErrorFile, errorFile }) {

    const handleClose = () => {
        onHide();
        // onHideUploadModal();
        setErrorMessage('');
        setErrorFile(null);
    }

    const downloadErrorFile = () => {
        if (errorFile) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(errorFile);
            link.download = "Error-Summary-Report.xlsx";
            link.click();
            URL.revokeObjectURL(link.href);
            setErrorFile(null);
            onHide();
        }
    };
    

    return (
        <>
        
            <Modal show={isShow} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{message}</p>
                    <div className="d-flex justify-content-end gap-2">
                    <button onClick={handleClose} className="btn btn-secondary btn-sm">Cancel</button>
                    <button onClick={downloadErrorFile} className="btn btn-primary btn-sm">
                        Download Error File
                    </button>
                </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ErrorfeedbackModal;